const styles = () => ({
  section: {
    padding: '0px 15px 0',
    borderBottom: '1px solid rgba(155,173,188,0.30)',
    '&:last-of-type': {
      borderBottom: 'none',
    },
    display: 'flex',
    flexDirection: 'column',
  },

  sectionHeadingPlus: {
    width: 10,
    height: 10,
    marginRight: 5,
  },

  teams: {
    paddingLeft: 0,
    paddingRight: 0,
  },

  currentTag: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 16,
    color: '#ffffff',
    fontSize: 11,
    fontWeight: 500,
    backgroundColor: '#7b8b99',
    borderRadius: 9,
    padding: '0 7px',
    marginLeft: 'auto',
    marginRight: 0,
  },

  accounts: {
    listStyleType: 'none',
    margin: 0,
    padding: '2px 0',
  },

  account: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    '&:hover': {
      background: 'rgba(225,233,240,0.25)',
    },
  },

  option: {
    fontFamily:
      "'Avenir Next Medium', 'Avenir Next', Avenir, Helvetica, Arial, sans-serif",
    fontWeight: 500,
    width: '100%',
    fontSize: 14,
    color: '#596168',
    padding: '8px 15px',
    margin: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    background: 'transparent',

    '&:hover': {
      color: '#596168',
    },
  },

  optionIcon: {
    flexShrink: 0,
    marginRight: 8,
  },

  accountSelected: {
    '& $name $teamName': {
      color: '#27282A',
    },
    '&:hover svg': {
      opacity: 1,
    },
    '& $option': {
      padding: '3px 15px',
    },
  },

  createTeamIcon: {
    position: 'relative',
    marginLeft: 1,
    marginRight: 9,
  },

  name: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },

  teamName: {
    color: '#596168',
  },

  manageTeamLink: {
    color: '#148CFC',
    display: 'flex',
    alignItems: 'center',

    '& svg': {
      opacity: 0,
      transition: 'ease opacity 0.1s',
      position: 'relative',
      left: 4,
    },
  },
});

export default styles;
